// extracted by mini-css-extract-plugin
export default {"label":"ActivityPreview-module__label","activityList":"ActivityPreview-module__activityList","fee":"ActivityPreview-module__fee"};